import Layout1x1 from 'components/Layout1x1';
import Line from 'components/Line';
import Link from 'next/link';

const TiesCopy = () => (
  <>
    <Layout1x1>
      <h3 className="text-h2">About Our Tuxedo & Suit Ties</h3>
      <Line />
      <p>
        Generation Tux ties are available in a variety of styles, patterns and colors. Perfect for both suits and tuxedos, these ties will
        work for any occasion and perfectly{' '}
        <Link href="/how-it-works/swatches" className="tracker-text-collection-swatches-221226-164200">
          coordinate with bridesmaids
        </Link>
        , wedding parties, linens, florals and more.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tie Styles</h3>
      <p>
        From tuxedo bow ties, to long ties to pre-tied ties, Generation Tux has everything you need to complete your formal wear look.
        Whether you're the groom, the groomsmen, the father of the bride, or a guest, Generation Tux has a tie that you'll love.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tie Patterns</h3>
      <p>
        Ties don't have to be just solid. At Generation Tux they come in a variety of patterns. From striped ties, to zigzag, plaid and
        paisley, all the way to polka dotted ties, we've got something to add fun and style to your suit or tuxedo.
      </p>
    </Layout1x1>

    <Layout1x1 className="mt-56">
      <h3 className="text-h2">Tie Colors</h3>
      <p>
        Show your personality with your tie color. With a rainbow of tie colors and hues available, you'll easily find something to express
        yourself. Match your suit or tuxedo with more than 400 ties to choose from. From{' '}
        <Link href="/collection/ties?color=Pink" className="tracker-text-collection-champagne_ties-221226-164600">
          champagne ties
        </Link>
        , emerald ties, to nude ties, you'll find something that'll work for every season and type of event.
      </p>
    </Layout1x1>
  </>
);

export default TiesCopy;
